export const storeGlobalSettings = (state, globalSetting) => {
  state.globalSettings = { ...globalSetting };
  localStorage.setItem('globalSettings', JSON.stringify(globalSetting));
};
